export default __webpack_public_path__ + "static/media/tt.9fa24984.png";